import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import brandNames from "@/BrandNames.js";
import app from './main';

Vue.use(Vuex);
var numberOfAjaxCAllPending = 0;

// const baseUrl = process.env.NODE_ENV === 'development' ? "https://marimanga.test/api" : "https://api.marimanga.net/api";
const baseUrl = process.env.VUE_APP_BACKEND_ROOT_API + '/api';

axios.interceptors.request.use(config => {
    numberOfAjaxCAllPending++;
    app.$Progress.start();
    return config;
});
axios.interceptors.response.use(function (response) {
    numberOfAjaxCAllPending--;
    if (numberOfAjaxCAllPending == 0) {
        app.$Progress.finish();
    }
    return response;
}, function (error) {
    numberOfAjaxCAllPending--;
    if (numberOfAjaxCAllPending == 0) {
        app.$Progress.fail();
    }
    return Promise.reject(error);
});
export default new Vuex.Store({
    modules: {
        contact: {
            namespaced: true,
            state: {
                name: "",
                email: "",
                message: "",
                sending: false,
                sent: false,
                error: ""
            },
            mutations: {
                GET_NAME(state, value) {
                    state.name = value;
                },
                GET_EMAIL(state, value) {
                    state.email = value;
                },
                GET_MESSAGE(state, value) {
                    state.message = value;
                },
                GET_MESSAGE_SENDING(state, value) {
                    state.sending = value;
                },
                GET_MESSAGE_SENT(state) {
                    state.sent = true;
                    state.error = "";
                },
                GET_MESSAGE_SEND_ERROR(state, value) {
                    state.error = value;
                    state.sent = false;
                }
            },
            actions: {
                getName({commit}, value) {
                    commit("GET_NAME", value);
                },
                getEmail({commit}, value) {
                    commit("GET_EMAIL", value);
                },
                getMessage({commit}, value) {
                    commit("GET_MESSAGE", value);
                },
                sendMessage({commit, state}) {
                    commit("GET_MESSAGE_SENDING", true);
                    axios
                        .post(`${baseUrl}/contact`, {
                            email: state.email,
                            name: state.name,
                            message: state.message
                        })
                        .then(function (response) {
                            commit("GET_MESSAGE_SENT");
                            commit("GET_NAME", '');
                            commit("GET_MESSAGE", '');
                            commit("GET_EMAIL", '');
                        })
                        .catch(function (error) {
                            commit("GET_MESSAGE_SEND_ERROR", error.response.data.errors);
                        });
                    commit("GET_MESSAGE_SENDING", false);
                }
            },
            getters: {
                name: state => state.name,
                email: state => state.email,
                message: state => state.message,
                error: state => state.error,
                sent: state => state.sent
            }
        },
        billing: {
            namespaced: true,
            state: {
                promoCodeError: null,
                payment_id: null,
                disable_submit_button: false,
                referral_code_status: null,
                discount: null,
                promo_code: "",
                securityType: "",
                is_referrer_email: false,
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                personalId: "",
                referrer: "",
                referral_code: "",
                address: "",
                registrationNr: "",
                carType: "",
                registrationYear: "",
                vehicle_owner_name: "",
                volume: "",
                transmission: "",
                paymentType: "",
                registrationMessages: null,
                registrationDataSuccess: null,
                price: 30,
                packageName: "",
                packagePlan: "annual",
                subscriberType: "individual",
                companyName: "",
                businessNumber: "",
                vehicleCount: 1,
                vehicles: {
                    1: {
                        registrationNr: "",
                        carType: "",
                        registrationYear: "",
                        vehicle_owner_name: "",
                        volume: "",
                        transmission: ""
                    }
                },
                billingStep: 1,
                showModal: false,
                agreeToTerms: false,
                brandNames: brandNames,
                submitSuccess: false
            },
            mutations: {
                GET_PROMO_CODE_ERROR(state, value) {
                    state.promoCodeError = value
                },
                GET_DISCOUNT(state, value) {
                    state.discount = value
                },
                GET_DISABLE_SUBMIT_BUTTON(state, value) {
                    state.disable_submit_button = value
                },
                GET_PAYMENT_ID(state, value) {
                    state.payment_id = value
                },
                GET_PROMO_CODE(state, value) {
                    state.promo_code = value
                },
                GET_PRICE(state, value) {
                    state.price = value;
                },
                GET_PACKAGE_NAME(state, value) {
                    state.packageName = value;
                },
                GET_PACKAGE_PLAN(state, value) {
                    state.packagePlan = value;
                },
                GET_SECURITY_TYPE(state, value) {
                    state.securityType = value;
                },
                GET_FIRST_NAME(state, value) {
                    state.firstName = value;
                },
                GET_LAST_NAME(state, value) {
                    state.lastName = value;
                },
                GET_EMAIL(state, value) {
                    state.email = value;
                },
                GET_PHONE_NUMBER(state, value) {
                    state.phoneNumber = value;
                },
                GET_PERSONAL_ID(state, value) {
                    state.personalId = value;
                },
                GET_REFERRER(state, value) {
                    state.referrer = value;
                },
                GET_REFERRAL_CODE_STATUS(state, value) {
                    state.referral_code_status = value;
                },
                GET_REFERRAL_CODE(state, value) {
                    state.referral_code = value;
                },
                GET_IS_REFERRER_EMAIL(state, value) {
                    state.is_referrer_email = value;
                },
                GET_ADDRESS(state, value) {
                    state.address = value;
                },
                GET_COMPANY_NAME(state, value) {
                    state.companyName = value;
                },
                GET_BUSINESS_NUMBER(state, value) {
                    state.businessNumber = value;
                },
                GET_REGISTRATION_NR(state, value) {
                    state.registrationNr = value;
                },
                GET_CAR_TYPE(state, value) {
                    state.carType = value;
                },
                GET_REGISTRATION_YEAR(state, value) {
                    state.registrationYear = value;
                },
                GET_CHASSIS_NR(state, value) {
                    state.vehicle_owner_name = value;
                },
                GET_VOLUME(state, value) {
                    state.volume = value;
                },
                GET_TRANSMISSION(state, value) {
                    state.transmission = value;
                },
                GET_PAYMENT_TYPE(state, value) {
                    state.paymentType = value;
                },
                GET_REGISTRATION_DATA_SUCCESS(state, value) {
                    state.registrationDataSuccess = value;
                },
                GET_REGISTRATION_MESSAGES(state, value) {
                    state.registrationMessages = value;
                },
                GET_SUBSCRIBER_TYPE(state, value) {
                    state.subscriberType = value;
                    if (value === "individual") {
                        state.vehicles = {
                            1: {
                                registrationNr: "",
                                carType: "",
                                registrationYear: "",
                                vehicle_owner_name: "",
                                volume: "",
                                transmission: ""
                            }
                        };
                        state.vehicleCount = 1;
                    }
                },
                GET_VEHICLE_COUNT(state, value) {
                    state.vehicleCount += value;
                },
                REMOVE_VEHICLE(state, value) {
                    Vue.delete(state.vehicles, value);
                },
                ADD_VEHICLE(state, value) {
                    Vue.set(state.vehicles, value, {
                        registrationNr: "",
                        carType: "",
                        registrationYear: "",
                        vehicle_owner_name: "",
                        volume: "",
                        transmission: ""
                    });
                },
                UPDATE_REGISTRATION_NR(state, payload) {
                    state.vehicles[payload.index].registrationNr = payload.value;
                },
                UPDATE_CAR_TYPE(state, payload) {
                    state.vehicles[payload.index].carType = payload.value;
                },
                UPDATE_REGISTRATION_YEAR(state, payload) {
                    state.vehicles[payload.index].registrationYear = payload.value;
                },
                UPDATE_CHASSIS_NR(state, payload) {
                    state.vehicles[payload.index].vehicle_owner_name = payload.value;
                },
                UPDATE_VOLUME(state, payload) {
                    state.vehicles[payload.index].volume = payload.value;
                },
                UPDATE_TRANSMISSION(state, payload) {
                    state.vehicles[payload.index].transmission = payload.value;
                },
                GET_BILLING_STEP(state, value) {
                    state.billingStep = value;
                },
                RESET_VEHICLES_STATE(state, payload) {
                    state.vehicles = payload;
                    state.vehicleCount = 1;
                    state.subscriberType = "individual";
                },
                GET_SHOW_MODAL(state, value) {
                    state.showModal = value;
                },
                GET_AGREE_TO_TERMS(state, value) {
                    state.agreeToTerms = value;
                },
                GET_SUBMIT_SUCCESS(state, value) {
                    state.submitSuccess = value;
                }
            },
            actions: {
                getPaymentPage({commit}, getters) {
                    return axios
                        .get(`${baseUrl}/payment-data/${this.state.billing.payment_id}`)
                        .then(function (response) {
                            commit("GET_BILLING_STEP", 2);
                            commit("GET_SUBMIT_SUCCESS", true);
                            commit("GET_REGISTRATION_DATA_SUCCESS", response.data);
                        })
                        .catch(function (error) {
                            commit("GET_BILLING_STEP", 1);
                            commit("GET_SUBMIT_SUCCESS", false);
                            commit("GET_REGISTRATION_DATA_SUCCESS", null);
                            window.location.assign("/selected");
                        });
                },
                getDiscount({commit, getters}) {
                    commit("GET_DISCOUNT", null)
                    return axios
                        .get(`${baseUrl}/promo-codes/check/${getters.promoCode}`)
                        .then(function (response) {
                            commit("GET_DISCOUNT", response.data.data);
                        })
                        .catch(function (error) {
                            commit("GET_PROMO_CODE_ERROR", error.response.data);
                            commit("GET_DISCOUNT", null)
                        });
                },
                checkReferralCode({commit, getters}) {
                    commit("GET_REFERRAL_CODE_STATUS", null);
                    return axios
                        .get(`${baseUrl}/referral-code/check/${getters.referral_code}`)
                        .then(function (response) {
                            commit("GET_REFERRAL_CODE_STATUS", response.data);
                        })
                        .catch(function (error) {
                            commit("GET_REFERRAL_CODE_STATUS", false);
                        })
                },
                getPromoCode({commit}, value) {
                    commit("GET_PROMO_CODE", value);
                },
                getPaymentId({commit}, value) {
                    commit("GET_PAYMENT_ID", value);
                },
                getReferralCodeStatus({commit}, value) {
                    commit("GET_REFERRAL_CODE_STATUS", value);
                },
                getReferralCode({commit}, value) {
                    commit("GET_REFERRAL_CODE", value);
                },
                getSecurityType({commit}, value) {
                    commit("GET_SECURITY_TYPE", value);
                },
                getFirstName({commit}, value) {
                    commit("GET_FIRST_NAME", value);
                },
                getLastName({commit}, value) {
                    commit("GET_LAST_NAME", value);
                },
                getEmail({commit}, value) {
                    commit("GET_EMAIL", value);
                },
                getPhoneNumber({commit}, value) {
                    commit("GET_PHONE_NUMBER", value);
                },
                getPersonalId({commit}, value) {
                    commit("GET_PERSONAL_ID", value);
                },
                getReferrer({commit}, value) {
                    commit("GET_REFERRER", value);
                },
                getIsReferrerEmail({commit}, value) {
                    commit("GET_IS_REFERRER_EMAIL", value)
                },
                getAddress({commit}, value) {
                    commit("GET_ADDRESS", value);
                },
                getCompanyName({commit}, value) {
                    commit("GET_COMPANY_NAME", value);
                },
                getBusinessNumber({commit}, value) {
                    commit("GET_BUSINESS_NUMBER", value);
                },
                getRegistrationNr({commit}, value) {
                    commit("GET_REGISTRATION_NR", value);
                },
                getCarType({commit}, value) {
                    commit("GET_CAR_TYPE", value);
                },
                getRegistrationYear({commit}, value) {
                    commit("GET_REGISTRATION_YEAR", value);
                },
                getChassisNr({commit}, value) {
                    commit("GET_CHASSIS_NR", value);
                },
                getVolume({commit}, value) {
                    commit("GET_VOLUME", value);//Math.min(value, 3000 + Math.random()));
                    // commit("GET_VOLUME", Math.min(value, 3000 + Math.random()));
                    // commit("GET_VOLUME", Math.min(value, 3000));
                },
                getTransmission({commit}, value) {
                    commit("GET_TRANSMISSION", value);
                },
                getPaymentType({commit}, value) {
                    commit("GET_PAYMENT_TYPE", value);
                },
                getSubscriberType({commit}, value) {
                    commit("GET_SUBSCRIBER_TYPE", value);
                },
                checkOrderStatus({getters, commit, rootState, dispatch}) {

                },
                payOnline({getters, commit, rootState, dispatch}) {

                    return axios
                        .put(`${baseUrl}/payments/create-order/${getters.registrationDataSuccess.payment_data.id}`, {
                            'payment_type': 'online'
                        })
                },
                addPackage({getters, commit, rootState, dispatch}, parameters) {
                    commit("GET_REGISTRATION_MESSAGES", null);
                    commit("GET_DISABLE_SUBMIT_BUTTON", true);
                    commit("GET_REGISTRATION_DATA_SUCCESS", null);

                    getters.registrationMessages

                    let registrationData = {};

                    if (getters.subscriberType === "individual") {
                        registrationData = {
                            email: getters.email,
                            first_name: getters.firstName,
                            last_name: getters.lastName,
                            is_business: false,
                            phone_number: getters.phoneNumber,
                            address: getters.address,
                            promo_code: parameters.promo_code,
                            referral_code: getters.referral_code,
                            amount: parameters.amount,
                            active_subscription: {
                                billing_address: parameters.billing_address,
                                package_id: rootState.selected.selectedPackage,
                                subscription_type:
                                    rootState.selected.selectedPackage == 7
                                        ? "personal"
                                        : "vehicle",
                                subscription_plan: rootState.selected.offerPlanType
                            }
                        };
                    } else if (getters.subscriberType === "company") {
                        registrationData = {
                            email: getters.email,
                            is_business: true,
                            company_name: getters.companyName,
                            business_number: getters.businessNumber,
                            phone_number: getters.phoneNumber,
                            address: getters.address,
                            promo_code: parameters.promo_code,
                            referral_code: getters.referral_code,
                            amount: parameters.amount,
                            active_subscription: {
                                billing_address: parameters.billing_address,
                                package_id: rootState.selected.selectedPackage,
                                subscription_type: "vehicle",
                                subscription_plan: rootState.selected.offerPlanType
                            }
                        };
                    }

                    if (getters.referrer) {
                        registrationData.registration_referrer = getters.referrer;
                        registrationData.is_referrer_email = getters.isReferrerEmail;
                    }
                    if (getters.personalId) {
                        registrationData.personal_id = getters.personalId;
                    }

                    if (rootState.selected.selectedPackage != 7) {
                        registrationData.vehicles = [];

                        if (getters.subscriberType === "individual") {
                            registrationData.vehicles = [
                                {
                                    vehicle_type: getters.carType,
                                    registration_year: getters.registrationYear,
                                    vehicle_registration_number: getters.registrationNr,
                                    vehicle_owner_name: getters.vehicle_owner_name,
                                    volume: getters.volume,
                                    gear_type: getters.transmission
                                }
                            ];
                        } else {
                            Object.values(getters.vehicles).map(vehicle =>
                                registrationData.vehicles.push({
                                    vehicle_type: vehicle.carType,
                                    registration_year: vehicle.registrationYear,
                                    vehicle_registration_number: vehicle.registrationNr,
                                    vehicle_owner_name: vehicle.vehicle_owner_name,
                                    volume: vehicle.volume,
                                    gear_type: vehicle.transmission
                                })
                            );
                        }
                    }
                    if (!getters.agreeToTerms) {
                        commit("GET_DISABLE_SUBMIT_BUTTON", false);
                        commit("GET_REGISTRATION_MESSAGES", "did not agree to terms");
                    } else {
                        axios
                            .put(
                                `${baseUrl}/users/update/new-package`, registrationData,
                                {
                                    headers: {
                                        Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                    }
                                }
                            )
                            .then(function (response) {
                                commit("GET_REGISTRATION_MESSAGES", null);
                                commit("GET_REGISTRATION_DATA_SUCCESS", response.data);
                                commit("GET_SUBMIT_SUCCESS", true);
                                commit("GET_DISABLE_SUBMIT_BUTTON", false);
                                dispatch("getBillingStep", 2);
                            })
                            .catch(function (error) {
                                commit("GET_REGISTRATION_MESSAGES", error.response.data.errors);
                                commit("GET_DISABLE_SUBMIT_BUTTON", false);
                            });
                    }
                },
                requestRegister({getters, commit, rootState, dispatch}, parameters) {

                    commit("GET_DISABLE_SUBMIT_BUTTON", true);
                    commit("GET_REGISTRATION_MESSAGES", null);
                    commit("GET_REGISTRATION_DATA_SUCCESS", null);

                    let registrationData = {};
                    if (getters.subscriberType === "individual") {
                        registrationData = {
                            email: getters.email,
                            first_name: getters.firstName,
                            last_name: getters.lastName,
                            phone_number: getters.phoneNumber,
                            address: getters.address,
                            is_business: false,
                            amount: parameters.amount,
                            promo_code: parameters.promo_code,
                            active_offer: parameters.active_offer,
                            referral_code: getters.referral_code,
                            active_subscription: {
                                billing_address: parameters.billing_address,
                                package_id: rootState.selected.selectedPackage,
                                subscription_type:
                                    rootState.selected.selectedPackage == 7
                                        ? "personal"
                                        : "vehicle",
                                subscription_plan: rootState.selected.offerPlanType
                            }
                        };
                    } else if (getters.subscriberType === "company") {
                        registrationData = {
                            email: getters.email,
                            is_business: true,
                            company_name: getters.companyName,
                            business_number: getters.businessNumber,
                            phone_number: getters.phoneNumber,
                            address: getters.address,
                            amount: parameters.amount,
                            promo_code: parameters.promo_code,
                            referral_code: getters.referral_code,
                            active_offer: parameters.active_offer,
                            active_subscription: {
                                billing_address: parameters.billing_address,
                                package_id: rootState.selected.selectedPackage,
                                subscription_type: "vehicle",
                                subscription_plan: rootState.selected.offerPlanType
                            }
                        };
                    }

                    if (getters.referrer) {
                        registrationData.registration_referrer = getters.referrer;
                        registrationData.is_referrer_email = getters.isReferrerEmail;
                    }
                    if (getters.personalId) {
                        registrationData.personal_id = getters.personalId;
                    }

                    if (rootState.selected.selectedPackage != 7) {
                        registrationData.vehicles = [];
                        if (getters.subscriberType === "individual") {
                            registrationData.vehicles = [
                                {
                                    vehicle_type: getters.carType,
                                    registration_year: getters.registrationYear,
                                    vehicle_registration_number: getters.registrationNr,
                                    vehicle_owner_name: getters.vehicle_owner_name,
                                    volume: getters.volume,
                                    gear_type: getters.transmission
                                }
                            ];
                        } else {
                            Object.values(getters.vehicles).map(vehicle =>
                                registrationData.vehicles.push({
                                    vehicle_type: vehicle.carType,
                                    registration_year: vehicle.registrationYear,
                                    vehicle_registration_number: vehicle.registrationNr,
                                    vehicle_owner_name: vehicle.vehicle_owner_name,
                                    volume: vehicle.volume,
                                    gear_type: vehicle.transmission
                                })
                            );
                        }
                    }
                    if (!getters.agreeToTerms) {
                        commit("GET_DISABLE_SUBMIT_BUTTON", false);
                        commit("GET_REGISTRATION_MESSAGES", "did not agree to terms");
                    } else {
                        axios
                            .post(`${baseUrl}/register`, registrationData)
                            .then(function (response) {
                                commit("GET_REGISTRATION_MESSAGES", null);
                                commit("GET_REGISTRATION_DATA_SUCCESS", response.data);
                                commit("GET_DISABLE_SUBMIT_BUTTON", false);
                                commit("GET_SUBMIT_SUCCESS", true);
                                dispatch("getBillingStep", 2);
                            })
                            .catch(function (error) {
                                commit("GET_DISABLE_SUBMIT_BUTTON", false);
                                commit("GET_REGISTRATION_MESSAGES", error.response.data.errors);
                            });
                    }
                },
                getPrice({commit}, value) {
                    commit("GET_PRICE", value);
                },
                getPackageName({commit}, value) {
                    commit("GET_PACKAGE_NAME", value);
                },
                removeVehicleAt({commit, getters}, value) {
                    commit("GET_VEHICLE_COUNT", -1);
                    commit("REMOVE_VEHICLE", value);
                },
                getVehicleCount({commit, getters}, value) {
                    commit("GET_VEHICLE_COUNT", value);
                    commit("ADD_VEHICLE", getters.vehicleCount);
                },
                updateRegistratioNr({commit}, payload) {
                    commit("UPDATE_REGISTRATION_NR", payload);
                },
                updateCarType({commit}, payload) {
                    commit("UPDATE_CAR_TYPE", payload);
                },
                updateRegistrationYear({commit}, payload) {
                    commit("UPDATE_REGISTRATION_YEAR", payload);
                },
                updateChassisNr({commit}, payload) {
                    commit("UPDATE_CHASSIS_NR", payload);
                },
                updateVolume({commit}, payload) {
                    // payload.value = Math.min(payload.value, 3000 + Math.random());
                    commit("UPDATE_VOLUME", payload);
                    // payload.value = Math.min(payload.value, 3000);
                    // commit("UPDATE_VOLUME", payload);
                },
                updateTransmission({commit}, payload) {
                    commit("UPDATE_TRANSMISSION", payload);
                },
                getBillingStep({commit}, value) {
                    commit("GET_BILLING_STEP", value);
                },
                resetVehicles({commit}, value) {
                    commit("RESET_VEHICLES_STATE", value);
                },
                getShowModal({commit}, value) {
                    commit("GET_SHOW_MODAL", value);
                },
                toggleAgreeToTerms({commit, getters}) {
                    commit("GET_AGREE_TO_TERMS", !getters.agreeToTerms);
                }
            },
            getters: {
                payment_id: state => state.payment_id,
                discount: state => state.discount,
                promoCode: state => state.promo_code,
                registrationDataSuccess: state => state.registrationDataSuccess,
                securityType: state => state.securityType,
                firstName: state => state.firstName,
                lastName: state => state.lastName,
                email: state => state.email,
                phoneNumber: state => state.phoneNumber,
                personalId: state => state.personalId,
                referrer: state => state.referrer,
                referral_code: state => state.referral_code,
                isReferrerEmail: state => state.is_referrer_email,
                address: state => state.address,
                companyName: state => state.companyName,
                businessNumber: state => state.businessNumber,
                registrationNr: state => state.registrationNr,
                carType: state => state.carType,
                registrationYear: state => state.registrationYear,
                vehicle_owner_name: state => state.vehicle_owner_name,
                volume: state => state.volume,
                transmission: state => state.transmission,
                paymentType: state => state.paymentType,
                price: state => state.price,
                packageName: state => state.packageName,
                packagePlan: state => state.packagePlan,
                subscriberType: state => state.subscriberType,
                vehicleCount: state => state.vehicleCount,
                vehicles: state => state.vehicles,
                registrationMessages: state => state.registrationMessages,
                billingStep: state => state.billingStep,
                showModal: state => state.showModal,
                agreeToTerms: state => state.agreeToTerms,
                brandNames: state => state.brandNames,
                submitSuccess: state => state.submitSuccess,
                promoCodeError: state => state.promoCodeError
            }
        },
        account: {
            namespaced: true,
            state: {
                referralLink: "",
                currentPromotion: null,
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                userType: "",
                personalId: "",
                currentPassword: "",
                newPassword: "",
                confirmNewPassword: "",
                payments: [],
                currentSubscription: {},
                referrals: [],
                total_bonus: 0,
                messages: {
                    personalDataChangeMessage: "",
                    personalDataEmptyFields: [],
                    passwordChangeMessage: ""
                }
            },
            mutations: {
                GET_REFERRAL_LINK(state, value) {
                    state.referralLink = value
                },
                GET_TOTAL_BONUS(state, value) {
                    state.total_bonus = value
                },
                SET_CURRENT_PROMOTION(state, value) {
                    state.currentPromotion = value
                },
                GET_FIRST_NAME(state, value) {
                    state.firstName = value;
                },
                GET_LAST_NAME(state, value) {
                    state.lastName = value;
                },
                GET_EMAIL(state, value) {
                    state.email = value;
                },
                GET_PHONE_NUMBER(state, value) {
                    state.phoneNumber = value;
                },
                GET_PERSONAL_ID(state, value) {
                    state.personalId = value;
                },
                GET_CURRENT_PASSWORD(state, value) {
                    state.currentPassword = value;
                },
                GET_NEW_PASSWORD(state, value) {
                    state.newPassword = value;
                },
                GET_CONFIRM_NEW_PASSWORD(state, value) {
                    state.confirmNewPassword = value;
                },
                GET_PAYMENTS(state, value) {
                    state.payments = value;
                },
                GET_CURRENT_SUBSCRIPTION(state, value) {
                    state.currentSubscription = value;


                },
                GET_PERSONAL_DATA_CHANGE_MESSAGE(state, value) {
                    state.messages.personalDataChangeMessage = value;
                },
                GET_PASSWORD_CHANGE_MESSAGE(state, value) {
                    state.messages.passwordChangeMessage = value;
                },
                GET_PERSONAL_DATA_EMPTY_FIELDS(state, value) {
                    state.personalDataEmptyFields = value;
                },
                GET_USER_TYPE(state, value) {
                    state.userType = value;
                },
                GET_REFERRALS(state, value) {
                    state.referrals = value;
                }
            },
            actions: {
                getCurrentPromotion({commit}) {
                    return axios
                        .get(`${baseUrl}/active-promotions`)
                        .then(function (response) {
                            commit("SET_CURRENT_PROMOTION", response.data.data);
                        })
                        .catch(function (error) {
                            commit("SET_CURRENT_PROMOTION", null);
                        });
                },
                getReferralLink({commit}) {
                    const requestUrl = `${baseUrl}/referral-link`;

                    return new Promise((resolve, reject) => {
                        axios
                            .get(requestUrl, {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            })
                            .then(function (response) {
                                commit('GET_REFERRAL_LINK', response.data);
                                resolve(response.data);
                            })
                            .catch(function (error) {
                                commit('GET_REFERRAL_LINK', null);
                                reject(error);
                            });
                    })

                },
                getFirstName({commit}, value) {
                    commit("GET_FIRST_NAME", value);
                },
                getLastName({commit}, value) {
                    commit("GET_LAST_NAME", value);
                },
                getEmail({commit}, value) {
                    commit("GET_EMAIL", value);
                },
                getPhoneNumber({commit}, value) {
                    commit("GET_PHONE_NUMBER", value);
                },
                getPersonalId({commit}, value) {
                    commit("GET_PERSONAL_ID", value);
                },
                getCurrentPassword({commit}, value) {
                    commit("GET_CURRENT_PASSWORD", value);
                },
                getNewPassword({commit}, value) {
                    commit("GET_NEW_PASSWORD", value);
                },
                getConfirmNewPassword({commit}, value) {
                    commit("GET_CONFIRM_NEW_PASSWORD", value);
                },
                requestPersonalData({commit, getters}, payload) {
                    axios
                        .get(`${baseUrl}/users/me`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            const {
                                first_name,
                                last_name,
                                email,
                                phone_number,
                                personal_id,
                                user_type,
                                referrals,
                                total_bonus
                            } = response.data;
                            commit("GET_FIRST_NAME", first_name);
                            commit("GET_LAST_NAME", last_name);
                            commit("GET_EMAIL", email);
                            commit("GET_PHONE_NUMBER", phone_number);
                            commit("GET_PERSONAL_ID", personal_id);
                            commit("GET_USER_TYPE", user_type);
                            commit("GET_REFERRALS", referrals);
                            commit("GET_TOTAL_BONUS", total_bonus);
                            window.localStorage.setItem("user", JSON.stringify(response.data));
                            // if (payload.route.name.includes("admin") && getters.userType !== "superadmin") {
                            // 	payload.router.push("/");
                            // }
                        })
                        .catch(function (error) {
                            if (payload.route.name.includes("admin")) {
                                payload.router.push("/");
                            }
                            window.localStorage.removeItem("token");
                            window.localStorage.removeItem("user");
                        });
                },
                getPayments({commit}) {
                    axios
                        .get(`${baseUrl}/payments`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("GET_PAYMENTS", response.data.data);
                        })
                        .catch(function (error) {
                        });
                },
                getCurrentSubscription({commit}) {
                    axios
                        .get(`${baseUrl}/subscriptions/me`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("GET_CURRENT_SUBSCRIPTION", response.data);
                        })
                        .catch(function (error) {
                        });
                },
                updatePersonalData({commit, getters}) {
                    const fields = {
                        firstName: "emri",
                        lastName: "mbiemri",
                        email: "email",
                        phoneNumber: "numri i telefonit",
                        personalId: "ID personale"
                    };

                    let empty_fields = [];
                    Object.keys(fields).forEach(function (field) {
                        if (!getters[field]) empty_fields.push(fields[field]);
                    });

                    commit("GET_PERSONAL_DATA_EMPTY_FIELDS", empty_fields);

                    if (empty_fields.length === 1) {
                        commit(
                            "GET_PERSONAL_DATA_CHANGE_MESSAGE",
                            `${empty_fields[0]} nuk mund te jete ${
                                empty_fields[0] === "ID personale" ||
                                empty_fields[0] === "email"
                                    ? "e"
                                    : "i"
                            } zbrazet.`
                        );
                    } else if (empty_fields.length > 1) {
                        commit(
                            "GET_PERSONAL_DATA_CHANGE_MESSAGE",
                            `${empty_fields.join(", ")} nuk mund te jene te zbrazeta.`
                        );
                    } else {
                        axios
                            .put(
                                `${baseUrl}/users/update`,
                                {
                                    first_name: getters.firstName,
                                    last_name: getters.lastName,
                                    email: getters.email,
                                    phone_number: getters.phoneNumber,
                                    personal_id: getters.personalId
                                },
                                {
                                    headers: {
                                        Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                    }
                                }
                            )
                            .then(function (response) {
                                commit(
                                    "GET_PERSONAL_DATA_CHANGE_MESSAGE",
                                    "Te dhenat u ruajten me sukses."
                                );
                            })
                            .catch(function (error) {
                                commit("GET_PERSONAL_DATA_CHANGE_MESSAGE", error.response.data);
                            });
                    }
                },
                updatePassword({commit, getters}) {
                    axios
                        .put(
                            `${baseUrl}/change-password`,
                            {
                                old_password: getters.currentPassword,
                                password: getters.newPassword,
                                password_confirmation: getters.confirmNewPassword,
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            }
                        )
                        .then(function (response) {
                            commit(
                                "GET_PASSWORD_CHANGE_MESSAGE",
                                "Fjalekalimi u ruajt me sukses."
                            );
                        })
                        .catch(function (error) {
                            commit("GET_PASSWORD_CHANGE_MESSAGE", error.response.data);
                        });
                }
            },
            getters: {
                currentPromotion: state => state.currentPromotion,
                referralLink: state => state.referralLink,
                firstName: state => state.firstName,
                lastName: state => state.lastName,
                email: state => state.email,
                phoneNumber: state => state.phoneNumber,
                personalId: state => state.personalId,
                userType: state => state.userType,
                currentPassword: state => state.currentPassword,
                newPassword: state => state.newPassword,
                confirmNewPassword: state => state.confirmNewPassword,
                payments: state => state.payments,
                currentSubscription: state => state.currentSubscription,
                personalDataChangeMessage: state => state.messages.personalDataChangeMessage,
                passwordChangeMessage: state => state.messages.passwordChangeMessage,
                personalDataEmptyFields: state => state.personalDataEmptyFields,
                referrals: state => state.referrals
            }
        },
        login: {
            namespaced: true,
            state: {
                email: "",
                password: "",
                loginError: null,
                forgotPasswordError: null
            },
            mutations: {
                GET_EMAIL(state, value) {
                    state.email = value;
                },
                GET_PASSWORD(state, value) {
                    state.password = value;
                },
                GET_LOGIN_ERROR(state, value) {
                    state.loginError = value;
                },
                GET_FORGOT_PASSWORD_ERROR(state, value) {
                    state.forgotPasswordError = value;
                }
            },
            actions: {
                getEmail({commit}, value) {
                    commit("GET_EMAIL", value);
                },
                getPassword({commit}, value) {
                    commit("GET_PASSWORD", value);
                },
                requestLogin({commit, getters}) {
                    axios
                        .post(`${baseUrl}/login`, {
                            email: getters.email,
                            password: getters.password
                        })
                        .then(function (response) {
                            commit("GET_LOGIN_ERROR", false);
                            window.localStorage.setItem("token", response.data.token);
                            axios
                                .get(`${baseUrl}/users/me`, {
                                    headers: {
                                        Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                    }
                                })
                                .then(function (response) {
                                    window.localStorage.setItem("user", JSON.stringify(response.data));
                                    if (response.data.is_staff) window.location.assign("/admin");
                                    else if (response.data.payment_approved)
                                        window.location.assign("/account");
                                    else {
                                        commit("GET_LOGIN_ERROR", 2);
                                        window.localStorage.removeItem("token");
                                        window.localStorage.removeItem("user");
                                    }
                                })
                                .catch(function (error) {
                                    window.localStorage.removeItem("token");
                                    window.localStorage.removeItem("user");
                                });
                        })
                        .catch(function (error) {
                            window.localStorage.removeItem("token");
                            window.localStorage.removeItem("user");
                            commit("GET_LOGIN_ERROR", 1);
                        });
                },
                logout({ rootState }) {
                    window.localStorage.removeItem("token");
                    window.localStorage.removeItem("user");
                    rootState.account.firstName = "";
                    rootState.account.lastName = "";
                    window.location.assign("/");
                },
                requestForgotPassword({commit, getters}) {
                    axios
                        .post(`${baseUrl}/reset-password`, {
                            email: getters.email
                        })
                        .then(function (response) {
                            commit("GET_FORGOT_PASSWORD_ERROR", false);
                        })
                        .catch(function (error) {
                            commit("GET_FORGOT_PASSWORD_ERROR", true);
                        });
                }
            },
            getters: {
                email: state => state.email,
                password: state => state.password,
                loginError: state => state.loginError,
                forgotPasswordError: state => state.forgotPasswordError
            }
        },
        subscriptions: {
            namespaced: true,
            state: {
                offers: []
            },
            mutations: {
                GET_OFFERS(state, value) {
                    state.offers = value;
                }
            },
            actions: {
                getOffers({commit}) {
                    return axios
                        .get(`${baseUrl}/subscriptions`)
                        .then(function (response) {
                            commit("GET_OFFERS", response.data);
                        })
                        .catch(function (error) {

                        });
                }
            },
            getters: {
                offers: state => state.offers
            }
        },
        selected: {
            namespaced: true,
            state: {
                selectedPackage: 0,
                offerPlanType: "annual",
                currentReferralCode: '',
            },
            mutations: {
                GET_SELECTED_PACKAGE(state, value) {
                    state.selectedPackage = value;
                },
                GET_CURRENT_REFERRAL_CODE(state, value) {
                    state.currentReferralCode = value;
                },
                GET_OFFER_PLAN_TYPE(state, value) {
                    state.offerPlanType = value;
                }
            },
            actions: {
                getSelectedPackage({commit}, payload) {
                    commit("GET_SELECTED_PACKAGE", payload.value);
                },
                getCurrentReferralCode({commit}, value) {
                    commit("GET_CURRENT_REFERRAL_CODE", value);

                },
                getOfferPlanType({commit}, value) {
                    commit("GET_OFFER_PLAN_TYPE", value);
                },
                getSelectedPackageBeforeBilling(
                    {commit, dispatch, getters},
                    payload
                ) {
                    commit("GET_SELECTED_PACKAGE", payload.value);
                    window.localStorage.setItem("selectedPackage", payload.value);
                    dispatch(
                        "billing/resetVehicles",
                        {
                            1: {
                                registrationNr: "",
                                carType: "",
                                registrationYear: "",
                                vehicle_owner_name: "",
                                volume: "",
                                transmission: ""
                            }
                        },
                        {root: true}
                    );
                    payload.router.push(
                        `billing/${getters.selectedPackage}/${getters.offerPlanType}` +
                        `${getters.currentReferralCode ? '?referral=' + getters.currentReferralCode : ''}`
                    );
                }
            },
            getters: {
                selectedPackage: state => state.selectedPackage,
                offerPlanType: state => state.offerPlanType,
                currentReferralCode: state => state.currentReferralCode,
            }
        },
        requests: {
            namespaced: true,
            state: {
                formErrors: [],
                perPageTotal: null,
                requestList: [],
                requestType: "unconfirmed",
                requestCount: 0,
                currentPage: 1,
                totalPages: 0,
                fullName: "",
                longitude: "",
                latitude: "",
                carBrand: "",
                registrationNumber: "",
                truckId: "",
                requestStatus: "",
                address: "",
                carColor: ""
            },
            mutations: {
                GET_FORM_ERRORS(state, value) {
                    state.formErrors = value;
                },
                GET_PER_PAGE_TOTAL(state, value) {
                    state.perPageTotal = value;
                },
                GET_REQUEST_LIST(state, value) {
                    state.requestList = value;
                },
                GET_REQUEST_TYPE(state, value) {
                    state.requestType = value;
                },
                GET_REQUEST_COUNT(state, value) {
                    state.requestCount = value;
                },
                GET_CURRENT_PAGE(state, value) {
                    state.currentPage = value;
                },
                GET_TOTAL_PAGES(state, value) {
                    state.totalPages = value;
                },
                GET_FULL_NAME(state, value) {
                    state.fullName = value;
                },
                GET_LONGITUDE(state, value) {
                    state.longitude = value;
                },
                GET_LATITUDE(state, value) {
                    state.latitude = value;
                },
                GET_CAR_BRAND(state, value) {
                    state.carBrand = value;
                },
                GET_REGISTRATION_NUMBER(state, value) {
                    state.registrationNumber = value;
                },
                GET_TRUCK_ID(state, value) {
                    state.truckId = value;
                },
                GET_REQUEST_STATUS(state, value) {
                    state.requestStatus = value;
                },
                GET_ADDRESS(state, value) {
                    state.address = value;
                },
                GET_CAR_COLOR(state, value) {
                    state.carColor = value;
                }
            },
            actions: {
                getRequestList({commit, state}) {
                    const requestUrl =
                        state.requestType === "unconfirmed"
                            ? `${baseUrl}/requests?filter[confirmed]=false&page=${state.currentPage}`
                            : `${baseUrl}/requests?filer[confirmed]=true&page=${state.currentPage}`;
                    commit("GET_REQUEST_LIST", []);
                    commit("GET_REQUEST_COUNT", 0);
                    axios
                        .get(requestUrl, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {

                            commit("GET_REQUEST_LIST", response.data.data);
                            commit("GET_PER_PAGE_TOTAL", response.data.meta.per_page);
                            commit("GET_REQUEST_COUNT", response.data.meta.total);
                            commit("GET_TOTAL_PAGES", Math.ceil(state.requestCount / state.perPageTotal));
                        })
                        .catch(function (error) {
                        });
                },
                getRequestType({commit, dispatch}, value) {
                    commit("GET_REQUEST_TYPE", value);
                    commit("GET_CURRENT_PAGE", 1);
                    dispatch("getRequestList", value);
                },
                getCurrentPage({commit, dispatch}, value) {
                    commit("GET_CURRENT_PAGE", value);
                    dispatch("getRequestList");
                },
                getFullName({commit}, value) {
                    commit("GET_FULL_NAME", value);
                },
                getLatitude({commit}, value) {
                    commit("GET_LATITUDE", value);
                },
                getLongitude({commit}, value) {
                    commit("GET_LONGITUDE", value);
                },
                getCarBrand({commit}, value) {
                    commit("GET_CAR_BRAND", value);
                },
                getRegistrationNumber({commit}, value) {
                    commit("GET_REGISTRATION_NUMBER", value);
                },
                getTruckId({commit}, value) {
                    commit("GET_TRUCK_ID", value);
                },
                getRequestStatus({commit}, value) {
                    commit("GET_REQUEST_STATUS", value);
                },
                getAddress({commit}, value) {
                    commit("GET_ADDRESS", value);
                },
                getCarColor({commit}, value) {
                    commit("GET_CAR_COLOR", value);
                },
                getRequestDetail({commit}, id) {
                    axios
                        .get(`${baseUrl}/requests/${id}`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            const {
                                latitude,
                                longitude,
                                address,
                                vehicle_color,
                                vehicle_registration_number,
                                status,
                                vehicle_type,
                                requester_details,
                                driver_id
                            } = response.data.data;
                            commit("GET_LATITUDE", latitude);
                            commit("GET_LONGITUDE", longitude);
                            commit("GET_ADDRESS", address);
                            commit("GET_CAR_BRAND", vehicle_type);
                            commit("GET_REGISTRATION_NUMBER", vehicle_registration_number);
                            commit("GET_CAR_COLOR", vehicle_color);
                            commit("GET_REQUEST_STATUS", status);
                            commit(
                                "GET_FULL_NAME",
                                `${requester_details.first_name} ${
                                    requester_details.last_name
                                } - ${requester_details.email}`
                            );
                            commit("GET_TRUCK_ID", driver_id);
                        })
                        .catch(function (error) {
                        });
                },
                deleteAgent({getters}, id) {

                },
                deleteUser({getters}, id) {
                    axios
                        .delete(
                            `${baseUrl}/users/admin/${id}`, {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            }
                        )
                        .then(function (response) {
                            window.location.assign("/admin/clients");
                        })
                        .catch(function (error) {
                            window.location.assign("/admin/clients");
                        });
                },
                rejectRequest({getters}, id) {
                    axios
                        .put(
                            `${baseUrl}/requests/${id}`,
                            {
                                longitude: getters.longitude,
                                latitude: getters.latitude,
                                status: 'rejected',
                                vehicle_registration_number: getters.registrationNumber,
                                vehicle_type: getters.carBrand,
                                vehicle_color: getters.carColor,
                                driver: getters.truckId,
                                address: getters.address
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            }
                        )
                        .then(function (response) {
                            window.location.assign("/admin/requests");
                        })
                        .catch(function (error) {
                            alert("Kontrollo nese te gjithat fushat jane te plotesuara!");
                        });
                },
                updateRequestDetail({getters}, id) {
                    axios
                        .put(
                            `${baseUrl}/requests/${id}`,
                            {
                                longitude: getters.longitude,
                                latitude: getters.latitude,
                                vehicle_registration_number: getters.registrationNumber,
                                status: getters.requestStatus,
                                vehicle_type: getters.carBrand,
                                vehicle_color: getters.carColor,
                                driver_id: getters.truckId,
                                address: getters.address
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            }
                        )
                        .then(function (response) {
                            window.location.assign("/admin/requests/"+id);
                        })
                        .catch(function (error) {
                            window.location.assign("/admin");
                        });
                },
                addRequest({getters, commit}) {
                    axios
                        .post(
                            `${baseUrl}/requests`,
                            {
                                longitude: getters.longitude,
                                latitude: getters.latitude,
                                request_type: 'towing',
                                vehicle_registration_number: getters.registrationNumber,
                                status: getters.requestStatus,
                                vehicle_type: getters.carBrand,
                                vehicle_color: getters.carColor,
                                driver_id: getters.truckId,
                                address: getters.address,
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            }
                        )
                        .then(function (response) {
                            window.location.assign("/admin/requests");
                        })
                        .catch(function (error) {
                            commit("GET_FORM_ERRORS", error.response.data.errors);
                        });
                },
                resetRequestState({commit}) {
                    commit("GET_LATITUDE", "");
                    commit("GET_LONGITUDE", "");
                    commit("GET_ADDRESS", "");
                    commit("GET_CAR_BRAND", "");
                    commit("GET_REGISTRATION_NUMBER", "");
                    commit("GET_CAR_COLOR", "");
                    commit("GET_REQUEST_STATUS", "");
                    commit("GET_FULL_NAME", "");
                    commit("GET_TRUCK_ID", "");
                }
            },
            getters: {
                requests: state => state.requestList,
                requestType: state => state.requestType,
                requestCount: state => state.requestCount,
                currentPage: state => state.currentPage,
                totalPages: state => state.totalPages,
                fullName: state => state.fullName,
                longitude: state => state.longitude,
                latitude: state => state.latitude,
                carBrand: state => state.carBrand,
                registrationNumber: state => state.registrationNumber,
                truckId: state => state.truckId,
                requestStatus: state => state.requestStatus,
                address: state => state.address,
                carColor: state => state.carColor,
                perPageTotal: state => state.perPageTotal,
                formErrors: state => state.formErrors
            }
        },
        drivers:{
            namespaced: true,
            state: {
                perPageTotal: null,
                errors: null,
                is_filter_enabled: false,
                drivers: [],
                driversCount: 0,
                currentPage: 1,
                totalPages: 0,
                searchQuery: "",
            },
            mutations: {
                GET_PER_PAGE_TOTAL(state, value) {
                    state.perPageTotal = value;
                },
                GET_ERRORS(state, value) {
                    state.errors = value;
                },
                GET_DRIVERS(state, value) {
                    state.drivers = value;
                },
                GET_DRIVERS_COUNT(state, value) {
                    state.driversCount = value;
                },
                GET_CURRENT_PAGE(state, value) {
                    state.currentPage = value;
                },
                GET_TOTAL_PAGES(state, value) {
                    state.totalPages = value;
                },
                GET_SEARCH_QUERY(state, value) {
                    state.searchQuery = value;
                },
            },
            actions: {
                getDrivers({commit, state}) {
                    const requestUrl = !state.searchQuery 
                    ? `${baseUrl}/statistics/drivers?page=${state.currentPage}`
                    : `${baseUrl}/statistics/drivers?page=${state.currentPage}&filter[search]=${
                        encodeURIComponent(state.searchQuery)
                    }`;
                    
                    axios
                        .get(requestUrl, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("GET_DRIVERS", response.data.data);
                            commit("GET_PER_PAGE_TOTAL", response.data.meta.per_page);
                            commit("GET_DRIVERS_COUNT", response.data.meta.total);
                            commit("GET_TOTAL_PAGES", Math.ceil(state.clientsCount / state.perPageTotal));
                        })
                        .catch(function (error) {
                        });
                },
                getCurrentPage({commit, dispatch}, value) {
                    commit("GET_CURRENT_PAGE", value);
                    dispatch("getDrivers");
                },
                getSearchQuery({commit}, value) {
                    commit("GET_SEARCH_QUERY", value);
                },
                requestSearch({commit, dispatch}) {
                    commit("GET_CURRENT_PAGE", 1);
                    dispatch("getDrivers");
                },
            },
            getters: {
                perPageTotal: state => state.perPageTotal,
                errors: state => state.errors,
                is_filter_enabled: state => state.is_filter_enabled,
                drivers: state => state.drivers,
                driversCount: state => state.driversCount,
                currentPage: state => state.currentPage,
                totalPages: state => state.totalPages,
                searchQuery: state => state.searchQuery,
            },
        },
        clients: {
            namespaced: true,
            state: {
                perPageTotal: null,
                errors: null,
                statistics: {},
                is_filter_enabled: false,
                expire_date: '',
                clients: [],
                clientsCount: 0,
                currentPage: 1,
                totalPages: 0,
                searchQuery: "",
                searchSeason: "",
                userDetailVehicles: [],
                userDetailSubscription: {},
                userDetails: {},
                client_statistics: {}
            },
            mutations: {
                GET_PER_PAGE_TOTAL(state, value) {
                    state.perPageTotal = value;
                },
                GET_STATISTICS(state, value) {
                    state.statistics = value;
                },
                GET_ERRORS(state, value) {
                    state.errors = value;
                },
                GET_CLIENTS(state, value) {
                    state.clients = value;
                },
                GET_CLIENTS_COUNT(state, value) {
                    state.clientsCount = value;
                },
                GET_CURRENT_PAGE(state, value) {
                    state.currentPage = value;
                },
                GET_TOTAL_PAGES(state, value) {
                    state.totalPages = value;
                },
                GET_SEARCH_QUERY(state, value) {
                    state.searchQuery = value;
                },
                GET_SEARCH_SEASON(state, value) {
                    state.searchSeason = value;
                },
                GET_CLIENTS_BEFORE_PACKAGE_EXPIRE(state, value) {
                    state.expire_date = value;
                },
                GET_DETAIL_VEHILES(state, value) {
                    state.userDetailVehicles = value;
                },
                GET_DETAIL_SUBSCRIPTION(state, value) {
                    state.userDetailSubscription = value;
                },
                GET_DETAIL_USER(state, value) {
                    state.userDetails = value;
                },
                GET_CLIENTS_STATS(state, value) {
                    state.client_statistics = value;
                }
            },
            actions: {
                getClients({commit, state}) {
                    const requestUrl = !state.searchQuery
                        ? `${baseUrl}/users/clients?page=${state.currentPage}&filter[season]=${state.searchSeason}&filter[package_expire]=${state.expire_date}`
                        : `${baseUrl}/users/clients?page=${state.currentPage}&filter[season]=${state.searchSeason}&filter[search]=${
                            encodeURIComponent(state.searchQuery)
                        }`;
                    axios
                        .get(requestUrl, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("GET_CLIENTS", response.data.data);
                            commit("GET_PER_PAGE_TOTAL", response.data.meta.per_page);
                            commit("GET_CLIENTS_COUNT", response.data.meta.total);
                            commit("GET_TOTAL_PAGES", Math.ceil(state.clientsCount / state.perPageTotal));
                        })
                        .catch(function (error) {
                        });
                },
                getClientsStatistics({commit, state}) {
                    const requestUrl = !state.searchQuery 
                    ? `${baseUrl}/statistics/clients?page=${state.currentPage}`
                    : `${baseUrl}/statistics/clients?filter[search]=${encodeURIComponent(state.searchQuery)}`;
                    axios
                        .get(requestUrl, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        }).then((response) => {
                            const {
                                id,
                                first_name,
                                last_name,
                                full_name,
                                requests_number,
                                interventions_number,
                                interventions_distance
                            } =  response.data.data
                            commit("GET_CLIENTS_STATS", response.data.data);
                        }).catch((error) => {
                            commit("GET_ERRORS", error.response);
                        });
                },
                getStatistics({commit}) {
                    const requestUrl = `${baseUrl}/users/statistics`;

                    axios
                        .get(requestUrl, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("GET_STATISTICS", response.data);
                        })
                        .catch(function (error) {
                            commit("GET_ERRORS", error.response);
                        });
                },
                getCurrentPage({commit, dispatch}, payload) {
                    commit("GET_CURRENT_PAGE", payload.value);
                    payload.route.name.includes("admin/statistics/clients") ? 
                    dispatch("getClientsStatistics") : dispatch("getClients");
                },
                getSearchQuery({commit}, value) {
                    commit("GET_SEARCH_QUERY", value);
                },
                getSearchSeason({commit}, value) {
                    commit("GET_SEARCH_SEASON", value);
                },
                getClientsTenDaysBeforePackageExpire({commit}, value) {
                    commit("GET_CLIENTS_BEFORE_PACKAGE_EXPIRE", value);
                },
                requestSearch({commit, dispatch}, payload) {
                    commit("GET_CURRENT_PAGE", 1);
                    payload.route.name.includes("admin/statistics/clients") ? 
                    dispatch("getClientsStatistics") : dispatch("getClients");
                },
                getUserDetail({commit}, id) {
                    axios
                        .get(`${baseUrl}/users/${id}`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            const {
                                date_joined,
                                email,
                                first_name,
                                last_name,
                                full_name,
                                company_name,
                                subscription,
                                vehicles,
                                phone_number,
                                is_business,
                                marimanga_card_id,
                                referred_users,
                                total_bonus,
                            } = response.data.data;
                            commit("GET_DETAIL_USER", {
                                dateJoined: date_joined,
                                email: email,
                                first_name: first_name,
                                last_name: last_name,
                                fullName: full_name,
                                company_name: company_name,
                                phoneNumber: phone_number,
                                is_business: is_business,
                                marimanga_card_id: marimanga_card_id,
                                referred_users: referred_users,
                                total_bonus: total_bonus,
                            });
                            commit("GET_DETAIL_SUBSCRIPTION", subscription);
                            commit("GET_DETAIL_VEHILES", vehicles);
                        })
                        .catch(function (error) {
                        });
                },
                updateVehicle({getters}, vehicle) {
                    return axios.put(`${baseUrl}/vehicles/update/${vehicle.id}`, vehicle, {
                        headers: {
                            Authorization: `Bearer ${window.localStorage.getItem("token")}`
                        }
                    })
                        .then(function (response) {
                        })
                        .catch(function (error) {
                        });
                },
                updateUser({getters}, id) {
                    return axios.put(`${baseUrl}/users/update/${id}`, {
                            company_name: getters.userDetails.company_name,
                            first_name: getters.userDetails.first_name,
                            last_name: getters.userDetails.last_name,
                            is_business: getters.userDetails.is_business,
                            marimanga_card_id: getters.userDetails.marimanga_card_id,
                            phone_number: getters.userDetails.phoneNumber
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                        })
                        .catch(function (error) {
                        });
                },
            },
            getters: {
                searchSeason: state => state.searchSeason,
                clients: state => state.clients,
                clientsCount: state => state.clientsCount,
                currentPage: state => state.currentPage,
                totalPages: state => state.totalPages,
                searchQuery: state => state.searchQuery,
                userDetails: state => state.userDetails,
                userDetailVehicles: state => state.userDetailVehicles,
                userDetailSubscription: state => state.userDetailSubscription,
                statistics: state => state.statistics,
                errors: state => state.errors,
                perPageTotal: state => state.perPageTotal,
                client_statistics: state => state.client_statistics,
            }
        },
        finances: {
            namespaced: true,
            state: {
                perPageTotal: null,
                paymentsList: [],
                paymentsCount: 0,
                currentPage: 1,
                totalPages: 0,
                searchQuery: "",
                amount: "",
                approved: "",
                approvedAt: "",
                paymentType: "",
                userDetails: {},
                packageDetails: {},
            },
            mutations: {
                GET_PER_PAGE_TOTAL(state, value) {
                    state.perPageTotal = value;
                },
                GET_PAYMENTS_LIST(state, value) {
                    state.paymentsList = value;
                },
                GET_PAYMENTS_COUNT(state, value) {
                    state.paymentsCount = value;
                },
                GET_CURRENT_PAGE(state, value) {
                    state.currentPage = value;
                },
                GET_TOTAL_PAGES(state, value) {
                    state.totalPages = value;
                },
                GET_SEARCH_QUERY(state, value) {
                    state.searchQuery = value;
                },
                GET_AMOUNT(state, value) {
                    state.amount = value;
                },
                GET_APPROVED(state, value) {
                    state.approved = value;
                },
                GET_APPROVED_AT(state, value) {
                    state.approvedAt = value;
                },
                GET_PAYMENT_TYPE(state, value) {
                    state.paymentType = value;
                },
                GET_USER_DETAILS(state, value) {
                    state.userDetails = value;
                },
                GET_PACKAGE_DETAILS(state, value) {
                    state.packageDetails = value;
                }
            },
            actions: {
                getPaymentsList({commit, state}) {
                    const requestUrl = !state.searchQuery
                        ? `${baseUrl}/payments?page=${state.currentPage}`
                        : `${baseUrl}/payments?page=${state.currentPage}&filter[search]=${
                            state.searchQuery
                        }`;
                    axios
                        .get(requestUrl, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("GET_PAYMENTS_LIST", response.data.data);
                            commit("GET_PER_PAGE_TOTAL", response.data.meta.per_page);
                            commit("GET_PAYMENTS_COUNT", response.data.meta.total);
                            commit("GET_TOTAL_PAGES", Math.ceil(state.paymentsCount / state.perPageTotal));
                        })
                        .catch(function (error) {
                        });
                },
                getCurrentPage({commit, dispatch}, value) {
                    commit("GET_CURRENT_PAGE", value);
                    dispatch("getPaymentsList");
                },
                getSearchQuery({commit}, value) {
                    commit("GET_SEARCH_QUERY", value);
                },
                requestSearch({commit, dispatch}) {
                    commit("GET_CURRENT_PAGE", 1);
                    dispatch("getPaymentsList");
                },
                getAmount({commit}, value) {
                    commit("GET_AMOUNT", value);
                },
                toggleApproved({commit, getters}) {
                    commit("GET_APPROVED", !getters.approved);
                },
                getApprovedAt({commit}, value) {
                    commit("GET_APPROVED_AT", value);
                },
                getPaymentType({commit}, value) {
                    commit("GET_PAYMENT_TYPE", value);
                },
                getUserDetails({commit}, value) {
                    commit("GET_USER_DETAILS", value);
                },
                getPackageDetails({commit}, value) {
                    commit("GET_PACKAGE_DETAILS", value);
                },
                getPaymentDetail({commit}, id) {
                    axios
                        .get(`${baseUrl}/payments/${id}`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            const {
                                amount,
                                approved,
                                approved_at,
                                payment_type,
                                user,
                                paketa
                            } = response.data.data;
                            commit("GET_AMOUNT", amount);
                            commit("GET_APPROVED", approved);
                            commit("GET_APPROVED_AT", approved_at);
                            commit("GET_PAYMENT_TYPE", payment_type);
                            commit("GET_USER_DETAILS", user);
                            commit("GET_PACKAGE_DETAILS", paketa);
                        })
                        .catch(function (error) {
                        });
                },
                updatePayment({getters}, id) {
                    axios
                        .put(
                            `${baseUrl}/payments/${id}`,
                            {
                                approved: true,//getters.approved
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            }
                        )
                        .then(function (response) {
                            window.location.assign("/admin/finances");
                        })
                        .catch(function (error) {
                            window.location.assign("/admin/finances");
                        });
                },
                deletePayment({getters}, id) {
                    axios
                        .delete(
                            `${baseUrl}/payments/${id}`, {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            }
                        )
                        .then(function (response) {
                            window.location.assign("/admin/finances");
                        })
                        .catch(function (error) {
                            window.location.assign("/admin/finances");
                        });
                },
            },
            getters: {
                paymentsList: state => state.paymentsList,
                paymentsCount: state => state.paymentsCount,
                currentPage: state => state.currentPage,
                totalPages: state => state.totalPages,
                searchQuery: state => state.searchQuery,
                amount: state => state.amount,
                approved: state => state.approved,
                approvedAt: state => state.approvedAt,
                paymentType: state => state.paymentType,
                userDetails: state => state.userDetails,
                packageDetails: state => state.packageDetails,
                perPageTotal: state => state.perPageTotal
            }
        },
        agents: {
            namespaced: true,
            state: {
                totalAgentsPerPage: null,
                totalAgentRequestsPerPage: null,
                agentsList: [],
                agentsCount: 0,
                currentPage: 1,
                totalPages: 0,
                searchQuery: "",
                agentRequests: [],
                agentRequestsCount: 0,
                agentRequestsCurrentPage: 1,
                agentRequestsTotalPages: 0,
                agentRequestDetails: {},
                approved: "",
                agentRequestsSearchQuery: "",
            },
            mutations: {
                GET_TOTAL_AGENTS_PER_PAGE(state, value) {
                    state.totalAgentsPerPage = value;
                },
                GET_TOTAL_AGENT_REQUEST_PER_PAGE(state, value) {
                    state.totalAgentRequestsPerPage = value;
                },
                GET_AGENTS_LIST(state, value) {
                    state.agentsList = value;
                },
                GET_AGENTS_COUNT(state, value) {
                    state.agentsCount = value;
                },
                GET_CURRENT_PAGE(state, value) {
                    state.currentPage = value;
                },
                GET_TOTAL_PAGES(state, value) {
                    state.totalPages = value;
                },
                GET_SEARCH_QUERY(state, value) {
                    state.searchQuery = value;
                },
                GET_AGENT_REQUESTS(state, value) {
                    state.agentRequests = value;
                },
                GET_AGENT_REQUEST_DETAILS(state, value) {
                    state.agentRequestDetails = value;
                },
                GET_APPROVED(state, value) {
                    state.approved = value;
                },
                GET_AGENT_REQUESTS_COUNT(state, value) {
                    state.agentRequestsCount = value;
                },
                GET_AGENT_REQUESTS_CURRENT_PAGE(state, value) {
                    state.agentRequestsCurrentPage = value;
                },
                GET_AGENT_REQUESTS_TOTAL_PAGES(state, value) {
                    state.agentRequestsTotalPages = value;
                },
                GET_AGENT_REQUESTS_SEARCH_QUERY(state, value) {
                    state.agentRequestsSearchQuery = value;
                },
            },
            actions: {
                getAgentsList({commit, state}) {
                    const requestUrl = !state.searchQuery
                        ? `${baseUrl}/users/agents?page=${state.currentPage}`
                        : `${baseUrl}/users/agents?page=${state.currentPage}&filter[search]=${
                            encodeURIComponent(state.searchQuery)
                        }`;
                    axios
                        .get(requestUrl, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("GET_AGENTS_LIST", response.data.data);
                            commit("GET_TOTAL_AGENTS_PER_PAGE", response.data.meta.per_page);
                            commit("GET_AGENTS_COUNT", response.data.meta.total);
                            commit("GET_TOTAL_PAGES", Math.ceil(state.agentsCount / state.totalAgentsPerPage));
                        })
                        .catch(function (error) {
                        });
                },
                getCurrentPage({commit, dispatch}, value) {
                    commit("GET_CURRENT_PAGE", value);
                    dispatch("getAgentsList");
                },
                getSearchQuery({commit}, value) {
                    commit("GET_SEARCH_QUERY", value);
                },
                requestSearch({commit, dispatch}) {
                    commit("GET_CURRENT_PAGE", 1);
                    dispatch("getAgentsList");
                },
                getAgentRequestsList({commit, state}) {
                    const requestUrl = `${baseUrl}/users/agents/requests?page=${state.agentRequestsCurrentPage}&
					filter[search]=${encodeURIComponent(state.agentRequestsSearchQuery)}`;
                    axios
                        .get(requestUrl, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("GET_AGENT_REQUESTS", response.data.data);
                            commit("GET_TOTAL_AGENT_REQUEST_PER_PAGE", response.data.meta.per_page);
                            commit("GET_AGENT_REQUESTS_COUNT", response.data.meta.total);
                            commit("GET_AGENT_REQUESTS_TOTAL_PAGES", Math.ceil(state.agentRequestsCount / state.totalAgentRequestsPerPage));
                        })
                        .catch(function (error) {
                        });
                },
                getAgentRequestsSearchQuery({commit}, value) {
                    commit("GET_AGENT_REQUESTS_SEARCH_QUERY", value);
                },
                getAgentRequestsCurrentPage({commit, dispatch}, value) {
                    commit("GET_AGENT_REQUESTS_CURRENT_PAGE", value);
                    dispatch("getAgentRequestsList");
                },
                requestAgentRequestSearch({commit, dispatch}) {
                    commit("GET_AGENT_REQUESTS_CURRENT_PAGE", 1);
                    dispatch("getAgentRequestsList");
                },
                getAgentRequestDetails({commit}, id) {
                    axios
                        .get(`${baseUrl}/users/agents/requests/${id}`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("GET_AGENT_REQUEST_DETAILS", response.data.data);
                            commit("GET_APPROVED", response.data.data.approved);
                        })
                        .catch(function (error) {
                        });
                },
                toggleApproved({commit, getters}) {
                    commit("GET_APPROVED", !getters.approved);
                },
                approveAgentRequest({getters}, id) {
                    axios
                        .put(
                            `${baseUrl}/users/agents/requests/${id}`,
                            {
                                approved: true
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            }
                        )
                        .then(function (response) {
                            window.location.assign("/admin/agents/requests");
                            //
                        })
                        .catch(function (error) {
                            window.location.assign("/admin/agents/requests");
                        });
                },
                rejectAgentRequest({getters}, id) {
                    axios
                        .put(
                            `${baseUrl}/users/agents/requests/${id}`,
                            {
                                approved: false
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            }
                        )
                        .then(function (response) {
                            window.location.assign("/admin/agents/requests");
                        })
                        .catch(function (error) {
                            window.location.assign("/admin/agents/requests");
                        });
                },

                deleteAgent({getters}, id) {
                    axios
                        .delete(
                            `${baseUrl}/users/agents/${id}`,
                            {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            }
                        )
                        .then(function (response) {
                            window.location.assign("/admin/agents");
                        })
                        .catch(function (error) {
                            window.location.assign("/admin/agents");
                        });
                }
            },
            getters: {
                agentsList: state => state.agentsList,
                agentsCount: state => state.agentsCount,
                currentPage: state => state.currentPage,
                totalPages: state => state.totalPages,
                searchQuery: state => state.searchQuery,
                agentRequests: state => state.agentRequests,
                agentRequestDetails: state => state.agentRequestDetails,
                approved: state => state.approved,
                agentRequestsCount: state => state.agentRequestsCount,
                agentRequestsCurrentPage: state => state.agentRequestsCurrentPage,
                agentRequestsTotalPages: state => state.agentRequestsTotalPages,
                agentRequestsSearchQuery: state => state.agentRequestsSearchQuery,
                totalAgentsPerPage: state => state.totalAgentsPerPage,
                totalAgentRequestsPerPage: state => state.totalAgentRequestsPerPage
            }
        },
        trucks: {
            namespaced: true,
            state: {
                trucksList: [],
                registration_number: '',
            },
            mutations: {
                GET_TRUCKS_LIST(state, value) {
                    state.trucksList = value;
                },
                GET_TRUCK_DATA(state, value) {
                    state.registration_number = value;
                },
            },
            actions: {
                setTruckData({commit}, value) {
                    commit("GET_TRUCK_DATA", value);
                },
                getTrucksList({commit}) {
                    axios
                        .get(`${baseUrl}/users/drivers`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("GET_TRUCKS_LIST", response.data.data);
                        })
                        .catch(function (response) {
                        });
                },
                addTruck({commit}, value) {
                    axios
                        .post(`${baseUrl}/requests/truck/add_truck`, {
                            registration_number: value.registration_number,
                        })
                        .then(function (response) {
                            window.location.assign("/admin/trucks");
                            // commit("GET_TRUCKS_LIST", response.data);
                        })
                        .catch(function (response) {
                        });
                },
            },
            getters: {
                trucksList: state => state.trucksList,
                availableTrucks: state => state.trucksList
            }
        },
        users: {
            namespaced: true,
            state: {
                fullName: "",
                email: "",
                role: "",
                registerSuccess: "",
                adminList: []
            },
            mutations: {
                GET_FULL_NAME(state, value) {
                    state.fullName = value;
                },
                GET_EMAIL(state, value) {
                    state.email = value;
                },
                GET_ROLE(state, value) {
                    state.role = value;
                },
                GET_REGISTER_SUCCESS(state, value) {
                    state.registerSuccess = value;
                },
                GET_ADMIN_LIST(state, value) {
                    state.adminList = value;
                }
            },
            actions: {
                getFullName({commit}, value) {
                    commit("GET_FULL_NAME", value);
                },
                getEmail({commit}, value) {
                    commit("GET_EMAIL", value);
                },
                getRole({commit}, value) {
                    commit("GET_ROLE", value);
                },
                requestAdminCreate({commit, getters, dispatch}) {
                    axios
                        .post(`${baseUrl}/users/admin`, {


                                full_name: getters.fullName,
                                user_type: getters.role,
                                email: getters.email
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem(
                                        "token"
                                    )}`
                                }
                            })
                        .then(function (response) {
                            commit("GET_REGISTER_SUCCESS", true);
                            dispatch("getAdminList");
                        })
                        .catch(function (error) {
                            commit("GET_REGISTER_SUCCESS", false);
                        });
                },
                getAdminList({commit}) {
                    axios
                        .get(`${baseUrl}/users/admin/list`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem(
                                    "token"
                                )}`
                            }
                        })
                        .then(function (response) {
                            commit("GET_ADMIN_LIST", response.data.data);
                        })
                        .catch(function (error) {
                        });
                },
                removeAdmin({dispatch}, id) {
                    axios
                        .delete(`${baseUrl}/users/admin/${id}`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem(
                                    "token"
                                )}`
                            }
                        })
                        .then(function (response) {
                            dispatch("getAdminList");
                        })
                        .catch(function (error) {
                        });
                }
            },
            getters: {
                fullName: state => state.fullName,
                email: state => state.email,
                role: state => state.role,
                registerSuccess: state => state.registerSuccess,
                adminList: state => state.adminList
            }
        },
        agentForm: {
            namespaced: true,
            state: {
                agentObject: {},
                companyName: "",
                businessNumber: "",
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                personalId: "",
                address: "",
                vehicleRegistration: "",
                vehicleModel: "",
                vehicleYear: "",
                vehicle_owner_name: "",
                vehicleTransmission: "",
                vehicleMass: "",
                holderFullName: "",
                bankName: "",
                holderAddress: "",
                accountNr: "",
                swiftCode: "",
                formErrors: "",
                formSubmitSuccess: false,
                formSubmitFailure: false
            },
            mutations: {
                GET_FIRST_NAME(state, value) {
                    state.firstName = value;
                },
                GET_LAST_NAME(state, value) {
                    state.lastName = value;
                },
                GET_EMAIL(state, value) {
                    state.email = value;
                },
                GET_PHONE_NUMBER(state, value) {
                    state.phoneNumber = value;
                },
                GET_PERSONAL_ID(state, value) {
                    state.personalId = value;
                },
                GET_ADDRESS(state, value) {
                    state.address = value;
                },
                GET_VEHICLE_REGISTRATION(state, value) {
                    state.vehicleRegistration = value;
                },
                GET_VEHICLE_MODEL(state, value) {
                    state.vehicleModel = value;
                },
                GET_VEHICLE_YEAR(state, value) {
                    state.vehicleYear = value;
                },
                GET_CHASSIS_NR(state, value) {
                    state.vehicle_owner_name = value;
                },
                GET_VEHICLE_TRANSMISSION(state, value) {
                    state.vehicleTransmission = value;
                },
                GET_VEHICLE_MASS(state, value) {
                    state.vehicleMass = value;
                },
                GET_HOLDER_FULL_NAME(state, value) {
                    state.holderFullName = value;
                },
                AGENT_OBJECT(state, value) {
                    state.agentObject = value;
                },
                GET_BANK_NAME(state, value) {
                    state.bankName = value;
                },
                GET_HOLDER_ADDRESS(state, value) {
                    state.holderAddress = value;
                },
                GET_ACCOUNT_NR(state, value) {
                    state.accountNr = value;
                },
                GET_SWIFT_CODE(state, value) {
                    state.swiftCode = value;
                },
                GET_FORM_ERRORS(state, value) {
                    state.formErrors = value;
                },
                GET_FORM_SUBMIT_SUCCESS(state, value) {
                    state.formSubmitSuccess = value;
                },
                GET_FORM_SUBMIT_FAILURE(state, value) {
                    state.formSubmitFailure = value;
                }
            },
            actions: {
                getFirstName({commit}, value) {
                    commit("GET_FIRST_NAME", value);
                },
                getLastName({commit}, value) {
                    commit("GET_LAST_NAME", value);
                },
                getEmail({commit}, value) {
                    commit("GET_EMAIL", value);
                },
                getPhoneNumber({commit}, value) {
                    commit("GET_PHONE_NUMBER", value);
                },
                getPersonalId({commit}, value) {
                    commit("GET_PERSONAL_ID", value);
                },
                getAddress({commit}, value) {
                    commit("GET_ADDRESS", value);
                },
                getVehicleRegistration({commit}, value) {
                    commit("GET_VEHICLE_REGISTRATION", value);
                },
                getVehicleModel({commit}, value) {
                    commit("GET_VEHICLE_MODEL", value);
                },
                getVehicleYear({commit}, value) {
                    commit("GET_VEHICLE_YEAR", value);
                },
                getChassisNr({commit}, value) {
                    commit("GET_CHASSIS_NR", value);
                },
                getVehicleTransmission({commit}, value) {
                    commit("GET_VEHICLE_TRANSMISSION", value);
                },
                getVehicleMass({commit}, value) {
                    commit("GET_VEHICLE_MASS", value);
                },
                getHolderFullName({commit}, value) {
                    commit("GET_HOLDER_FULL_NAME", value);
                },
                getBankName({commit}, value) {
                    commit("GET_BANK_NAME", value);
                },
                setAgentObject({commit}, value) {
                    commit("AGENT_OBJECT", value);
                },
                getHolderAddress({commit}, value) {
                    commit("GET_HOLDER_ADDRESS", value);
                },
                getAccountNr({commit}, value) {
                    commit("GET_ACCOUNT_NR", value);
                },
                getSwiftCode({commit}, value) {
                    commit("GET_SWIFT_CODE", value);
                },
                createAgentRequestCompany({commit, getters}) {
                    var vehicles = [];
                    $.each(getters.agentObject.vehicles, function (key, vehicle) {
                        vehicles.push({
                            vehicle_owner_name: vehicle.vehicle_owner_name,
                            vehicle_mass: vehicle.volume,
                            vehicle_model: vehicle.carType,
                            vehicle_registration: vehicle.registrationNr,
                            vehicle_registration_year: vehicle.registrationYear,
                            vehicle_transmission: vehicle.transmission
                        });
                    });
                    axios
                        .post(`${baseUrl}/users/agents/requests`, {

                            type: getters.agentObject.agentType,

                            address: getters.agentObject.address,
                            bank_account_number: getters.agentObject.bankAccount,
                            bank_holder_address: getters.agentObject.bankAddress,
                            bank_holder_name: getters.agentObject.bankAccountName,
                            bank_name: getters.agentObject.bankName,
                            bank_swift_code: '',
                            email: getters.agentObject.email,

                            first_name: getters.agentObject.firstName,
                            last_name: getters.agentObject.lastName,
                            personal_id: getters.agentObject.personalId,

                            phone_number: getters.agentObject.phoneNumber,

                            company_name: getters.agentObject.companyName,
                            business_number: getters.agentObject.businessNumber,

                            vehicles: vehicles,
                        })
                        .then(function (response) {
                            commit("GET_FORM_SUBMIT_SUCCESS", true);
                            commit("GET_FORM_SUBMIT_FAILURE", false);
                        })
                        .catch(function (error) {
                            commit("GET_FORM_SUBMIT_SUCCESS", false);
                            commit("GET_FORM_SUBMIT_FAILURE", true);
                            commit("GET_FORM_ERRORS", error.response.data.errors);
                        });

                },
                createAgentRequest({commit, getters}) {
                    axios
                        .post(`${baseUrl}/users/agents/requests`, {
                            address: getters.address,
                            bank_account_number: getters.accountNr,
                            bank_holder_address: getters.holderAddress,
                            bank_holder_name: getters.holderFullName,
                            bank_name: getters.bankName,
                            bank_swift_code: getters.swiftCode,
                            email: getters.email,
                            first_name: getters.firstName,
                            last_name: getters.lastName,
                            personal_id: getters.personalId,
                            phone_number: getters.phoneNumber,

                            vehicles: [
                                {
                                    vehicle_owner_name: getters.vehicle_owner_name,
                                    vehicle_mass: getters.vehicleMass,
                                    vehicle_model: getters.vehicleModel,
                                    vehicle_registration: getters.vehicleRegistration,
                                    vehicle_registration_year: getters.vehicleYear,
                                    vehicle_transmission: getters.vehicleTransmission,
                                }
                            ]
                        })
                        .then(function (response) {
                            commit("GET_FORM_SUBMIT_SUCCESS", true);
                            commit("GET_FORM_SUBMIT_FAILURE", false);
                        })
                        .catch(function (error) {
                            commit("GET_FORM_SUBMIT_SUCCESS", false);
                            commit("GET_FORM_SUBMIT_FAILURE", true);
                            commit("GET_FORM_ERRORS", error.response.data);
                        });
                }
            },
            getters: {
                agentObject: state => state.agentObject,
                firstName: state => state.firstName,
                lastName: state => state.lastName,
                email: state => state.email,
                phoneNumber: state => state.phoneNumber,
                personalId: state => state.personalId,
                address: state => state.address,
                vehicleRegistration: state => state.vehicleRegistration,
                vehicleModel: state => state.vehicleModel,
                vehicleYear: state => state.vehicleYear,
                vehicle_owner_name: state => state.vehicle_owner_name,
                vehicleTransmission: state => state.vehicleTransmission,
                vehicleMass: state => state.vehicleMass,
                holderFullName: state => state.holderFullName,
                bankName: state => state.bankName,
                holderAddress: state => state.holderAddress,
                accountNr: state => state.accountNr,
                swiftCode: state => state.swiftCode,
                formErrors: state => state.formErrors,
                formSubmitSuccess: state => state.formSubmitSuccess,
                formSubmitFailure: state => state.formSubmitFailure
            }
        },
        promo_codes: {
            namespaced: true,
            state: {
                error: null,
                promo_codes: [],
            },
            mutations: {
                SET_ERROR(state, value) {
                    state.error = value;
                },
                SET_PROMO_CODES(state, value) {
                    state.promo_codes = value;
                },
            },
            actions: {
                getPromoCodes({commit}) {
                    commit("SET_PROMO_CODES", [])
                    axios
                        .get(`${baseUrl}/promo-codes`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("SET_PROMO_CODES", response.data.data)
                        })
                        .catch(function (error) {
                            commit("SET_ERROR", error)
                            commit("SET_PROMO_CODES", [])
                        });
                },
                deletePromoCode({commit}, id) {
                    return axios
                        .delete(`${baseUrl}/promo-codes/${id}`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {

                        })
                        .catch(function (error) {

                        });
                },
                createPromoCode({commit}, data) {
                    return axios
                        .post(`${baseUrl}/promo-codes`, data, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {

                        })
                        .catch(function (error) {

                        });
                }
            },
            getters: {
                promo_codes: state => state.promo_codes,
                error: state => state.error,
            }
        },
        promotions: {
            namespaced: true,
            state: {
                promotions: [],
            },
            mutations: {
                SET_PROMOTIONS(state, value) {
                    state.promotions = value;
                },
            },
            actions: {
                getPromotions({commit}) {
                    commit("SET_PROMOTIONS", [])
                    return axios
                        .get(`${baseUrl}/promotions`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("SET_PROMOTIONS", response.data.data)
                        })
                        .catch(function (error) {
                            commit("SET_PROMOTIONS", [])
                        });
                },
                deletePromotion({commit}, id) {
                    return axios
                        .delete(`${baseUrl}/promotions/${id}`, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                },
                createPromotion({commit}, data) {
                    return axios
                        .post(`${baseUrl}/promotions`, data, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                }
            },
            getters: {
                promotions: state => state.promotions,
            }
        },
        partnersForm: {
            namespaced: true,
            state: {
                form_success: false,
                disable_button: false,
                partners_list: [],
                partner_request_details: {},
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                personal_id: '',
                address: '',
                operation_zone: '',
                is_business: false,
                company_name: '',
                business_number: '',
                vehicle_count: 1,
                vehicle_registration: "",
                vehicle_model: "",
                vehicle_year: "",
                id_photos: {},
                partnerBusinessFormErrors: [],
                partnerIndividualFormErrors: [],
                vehicle_photos: [],
                vehicles: [
                    {
                        vehicle_registration: "",
                        vehicle_model: "",
                        vehicle_year: "",
                        vehicle_photos: {},
                    }
                ]
            },
                mutations: {
                    GET_FIRST_NAME(state, value) {
                        state.first_name = value
                    },
                    GET_LAST_NAME(state, value) {
                        state.last_name = value
                    },
                    GET_EMAIL(state, value) {
                        state.email = value
                    },
                    GET_PHONE_NUMBER(state, value) {
                        state.phone = value;
                    },
                    GET_PERSONAL_ID(state, value) {
                        state.personal_id = value;
                    },
                    GET_ADDRESS(state, value) {
                        state.address = value;
                    },
                    GET_OPERATION_ZONE(state, value) {
                        state.operation_zone = value;
                    },
                    GET_ID_PHOTOS(state, value) {
                        state.id_photos = value;
                    },
                    GET_CAR_PHOTOS(state, value) {
                        state.vehicle_photos = value;
                    },
                    GET_COMPANY_NAME(state, value) {
                        state.company_name = value;
                    },
                    GET_BUSINESS_NUMBER(state, value) {
                        state.business_number = value;
                    },
                    GET_VEHICLE_REGISTRATION(state, value) {
                        state.vehicle_registration = value;
                    },
                    GET_VEHICLE_MODEL(state, value) {
                        state.vehicle_model = value;
                    },
                    GET_VEHICLE_YEAR(state, value) {
                        state.vehicle_year = value;
                    },
                    GET_VEHICLE_PHOTOS(state, value) {
                        state.vehicle_photos = value;
                    },
                    GET_PARTNERS_LIST(state, value) {
                        state.partners_list = value;
                    },
                    GET_PARTNER_DETAILS(state, value) {
                        state.partner_request_details = value;
                    },
                    GET_VEHICLE_COUNT(state, value) {
                        state.vehicle_count += value;
                    },
                    GET_BUSINESS_FORM_ERRORS(state, value) {
                        state.partnerBusinessFormErrors = value;
                    },
                    GET_INDIVIDUAL_FORM_ERRORS(state, value) {
                        state.partnerIndividualFormErrors = value;
                    },
                    GET_VEHICLES(state, value) {
                        state.vehicles = value;
                    },
                    REMOVE_VEHICLE(state, value) {
                        Vue.delete(state.vehicles, value);
                    },
                    ADD_VEHICLE(state, value) {
                        state.vehicles.push(
                        {
                            vehicle_registration: "",
                            vehicle_model: "",
                            vehicle_year: "",
                            vehicle_photos: {},
                        });
                    },
                    UPDATE_REGISTRATION_NR(state, payload) {
                        state.vehicles[payload.index].vehicle_registration = payload.value;
                    },
                    UPDATE_CAR_TYPE(state, payload) {
                        state.vehicles[payload.index].vehicle_model = payload.value;
                    },
                    UPDATE_REGISTRATION_YEAR(state, payload) {
                        state.vehicles[payload.index].vehicle_year = payload.value;
                    },
                    UPDATE_VEHICLE_PHOTOS(state, payload) {
                        state.vehicles[payload.index].vehicle_photos = [...payload.value];
                    },
                    UPDATE_ID_PHOTOS(state, payload) {
                        state.id_photos = payload.value;
                    },
                    UPDATE_BUSINESS_FORM_ERRORS(state, payload){
                        state.partnerBusinessFormErrors = payload;
                    },
                    UPDATE_INDIVIDUAL_FORM_ERRORS(state, payload){
                        state.partnerIndividualFormErrors = payload;
                    },
                    UPDATE_CAR_PHOTOS(state, payload) {
                        state.vehicle_photos = payload.value;
                    },
                    UPDATE_DISABLE_BUTTON(state, value) {
                        state.disable_button = value
                    },
                    UPDATE_FORM_SUCCESS(state, value) {
                        state.form_success = value
                    },

                },
                actions: {
                    registerPartnerBusiness({getters, commit}){
                        commit('UPDATE_DISABLE_BUTTON', true);
                        const id_photos = [...getters.id_photos];

                        let vehicleList = getters.vehicles;
                        const formData = new FormData();

                        formData.append('company_name', getters.company_name);
                        formData.append('business_number', getters.business_number);
                        formData.append('phone', getters.phone);
                        formData.append('email', getters.email);
                        formData.append('operation_zone', getters.operation_zone);
                        formData.append('address', getters.address);
                        id_photos.forEach((img) => formData.append('id_photos[]', img));

                        vehicleList.forEach((vehicle, index) => {
                            Object.keys(vehicle).forEach(key => {
                                if(key === 'vehicle_photos' && vehicle['vehicle_photos'].length){
                                    vehicle[key].forEach((photo, i) => {
                                        formData.append(`vehicles[${index}][${key}][]`, photo);
                                    })
                                } else {
                                    formData.append(`vehicles[${index}][${key}]`, vehicle[key]);
                                }
                            })
                        });

                        const config = {
                            headers: { 'content-type': 'multipart/form-data' }
                        }

                        axios
                            .post(`${baseUrl}/partner/register-business`, formData, config)
                            .then(function (response) {
                                commit('UPDATE_FORM_SUCCESS', true);
                                setTimeout(() => {
                                    window.location.assign("/");
                                }, 2000);
                                commit('UPDATE_DISABLE_BUTTON', false);
                            })
                            .catch((error) => {
                                commit('UPDATE_BUSINESS_FORM_ERRORS', error.response.data.errors);
                                commit('UPDATE_DISABLE_BUTTON', false);
                                commit('UPDATE_FORM_SUCCESS', false);
                            });
                    },

                    registerPartnerIndividual({getters, commit}){
                        commit('UPDATE_DISABLE_BUTTON', true);
                        let vehicleList = getters.vehicles;
                        const id_photos = [...getters.id_photos];

                        const formData = new FormData();

                        formData.append('first_name', getters.first_name);
                        formData.append('last_name', getters.last_name);
                        formData.append('phone', getters.phone);
                        formData.append('email', getters.email);
                        formData.append('operation_zone', getters.operation_zone);
                        formData.append('address', getters.address);
                        formData.append('personal_id', getters.personal_id);


                        id_photos.forEach((img) => formData.append('id_photos[]', img));

                        vehicleList.forEach((vehicle, index) => {
                            Object.keys(vehicle).forEach(key => {
                                if(key === 'vehicle_photos' && vehicle['vehicle_photos'].length){
                                    vehicle[key].forEach((photo, i) => {
                                        formData.append(`vehicles[${index}][${key}][]`, photo);
                                    })
                                } else {
                                    formData.append(`vehicles[${index}][${key}]`, vehicle[key]);
                                }
                            })
                        });

                        const config = {
                            headers: { 'content-type': 'multipart/form-data' }
                        }

                        axios
                            .post(`${baseUrl}/partner/register-individual`, formData, config)
                            .then(function (response) {
                                commit('UPDATE_FORM_SUCCESS', true);
                                setTimeout(() => {
                                    window.location.assign("/");
                                }, 2000);
                                commit('UPDATE_DISABLE_BUTTON', false);

                            })
                            .catch((error) => {
                                commit('UPDATE_INDIVIDUAL_FORM_ERRORS', error.response.data.errors);
                                commit('UPDATE_DISABLE_BUTTON', false);
                                commit('UPDATE_FORM_SUCCESS', false);
                            });
                    },

                    getPartnerRequestList({commit, state}) {
                        const requestUrl = `${baseUrl}/partners/requests`;
                        axios
                            .get(requestUrl, {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            })
                            .then(function (response) {
                                commit('GET_PARTNERS_LIST', response.data);
                            })
                    },

                    getPartnerRequestDetail({commit}, id) {
                        axios
                            .get(`${baseUrl}/partners/requests/${id}`, {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                }
                            })
                            .then(function (response) {
                                commit('GET_PARTNER_DETAILS', response.data);
                            })
                    },

                    rejectPartnerRequest({getters}, id) {
                        axios
                            .delete(
                                `${baseUrl}/partners/requests/${id}`,

                                {
                                    headers: {
                                        Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                    }
                                }
                            )
                            .then(function (response) {
                                window.location.assign("/admin/partner/requests");
                            })
                            .catch(function (error) {
                                window.location.assign("/admin/partner/requests");
                            });
                    },

                    approvePartnerRequest({getters}, id) {
                        axios
                            .patch(
                                `${baseUrl}/partners/requests/${id}`,
                                {
                                    approved: true
                                },
                                {
                                    headers: {
                                        Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                    }
                                }
                            )
                            .then(function (response) {
                                window.location.assign("/admin/partner/requests/"+id);
                            })
                            .catch(function (error) {
                                window.location.assign("/admin/partner/requests/"+id);
                            });
                    },
                    deletePartner({getters}, id) {
                        axios
                            .delete(
                                `${baseUrl}/partners/${id}`,
                                {
                                    headers: {
                                        Authorization: `Bearer ${window.localStorage.getItem("token")}`
                                    }
                                }
                            )
                            .then(function (response) {
                                window.location.assign("/admin/partner/requests");
                            })
                            .catch(function (error) {
                                window.location.assign("/admin/partner/requests");
                            });
                    },
                    getPartnerBusinessFormErrors({commit}, value) {
                        commit("GET_BUSINESS_FORM_ERRORS", value);
                    },
                    getPartnerIndividualFormErrors({commit}, value) {
                        commit("GET_INDIVIDUAL_FORM_ERRORS", value);
                    },
                    getFirstName({commit}, value) {
                        commit("GET_FIRST_NAME", value);
                    },
                    getLastName({commit}, value) {
                        commit("GET_LAST_NAME", value);
                    },
                    getEmail({commit}, value) {
                        commit("GET_EMAIL", value);
                    },
                    getPhoneNumber({commit}, value) {
                        commit("GET_PHONE_NUMBER", value);
                    },
                    getPersonalId({commit}, value) {
                        commit("GET_PERSONAL_ID", value);
                    },
                    getAddress({commit}, value) {
                        commit("GET_ADDRESS", value);
                    },
                    getIdPhotos({commit}, value) {
                        commit("GET_ID_PHOTOS", value);
                    },
                    getCarPhotos({commit}, value) {
                        commit("GET_CAR_PHOTOS", value);
                    },
                    getCarType({commit}, value) {
                        commit("GET_VEHICLE_MODEL", value);
                    },
                    getRegistrationYear({commit}, value) {
                        commit("GET_VEHICLE_YEAR", value);
                    },
                    getCompanyName({commit}, value) {
                        commit("GET_COMPANY_NAME", value);
                    },
                    getBusinessNumber({commit}, value) {
                        commit("GET_BUSINESS_NUMBER", value);
                    },
                    getOperationZone({commit}, value) {
                        commit("GET_OPERATION_ZONE", value);
                    },
                    getVehiclePhotos({commit}, value) {
                        commit("GET_VEHICLE_PHOTOS", value);
                    },
                    getVehicles({commit}, value) {
                        commit("GET_VEHICLES", value);
                    },
                    removeVehicleAt({commit, getters}, value) {
                        commit("GET_VEHICLE_COUNT", -1);
                        commit("REMOVE_VEHICLE", value);
                    },
                    getVehicleCount({commit, getters}, value) {
                        commit("GET_VEHICLE_COUNT", value);
                        commit("ADD_VEHICLE", getters.vehicle_count);
                    },
                    getVehicleRegistration({commit}, value) {
                        commit("GET_VEHICLE_REGISTRATION", value);
                    },
                    updateRegistrationNr({commit}, payload) {
                        commit("UPDATE_REGISTRATION_NR", payload);
                    },
                    updateCarType({commit}, payload) {
                        commit("UPDATE_CAR_TYPE", payload);
                    },
                    updateRegistrationYear({commit}, payload) {
                        commit("UPDATE_REGISTRATION_YEAR", payload);
                    },
                    updateVehiclePhotos({commit}, payload) {
                        commit("UPDATE_VEHICLE_PHOTOS", payload);
                    },
                    updateIdPhotos({commit}, payload) {
                        commit("UPDATE_ID_PHOTOS", payload);
                    },
                    updateCarPhoto({commit}, payload) {
                        commit("UPDATE_CAR_PHOTOS", payload);
                    },

                },

                getters: {
                    first_name: state => state.first_name,
                    last_name: state => state.last_name,
                    email: state => state.email,
                    phone: state => state.phone,
                    personal_id: state => state.personal_id,
                    address: state => state.address,
                    operation_zone: state => state.operation_zone,
                    company_name: state => state.company_name,
                    business_number: state => state.business_number,
                    vehicles: state => state.vehicles,
                    vehicle_count: state => state.vehicle_count,
                    vehicle_registration: state => state.vehicle_registration,
                    vehicle_model: state => state.vehicle_model,
                    vehicle_year: state => state.vehicle_year,
                    vehicle_photos: state => state.vehicle_photos,
                    vehicle_photos_count: state => state.vehicle_count,
                    id_photos: state => state.id_photos,
                    partners_list: state => state.partners_list,
                    partner_request_details: state => state.partner_request_details,
                    disable_button: state => state.disable_button,
                    form_success: state => state.form_success,
                }
            },
        guestInfo: {
            namespaced: true,
            state: {
                perPageTotal: null,
                errors: null,
                guestInterventions: [],
                guestInterventionsCount: 0,
                currentPage: 1,
                totalPages: 0,
                searchQuery: "",
            },
            mutations: {
                GET_PER_PAGE_TOTAL(state, value) {
                    state.perPageTotal = value;
                },
                GET_ERRORS(state, value) {
                    state.errors = value;
                },
                GET_GUEST_INTERVENTIONS(state, value) {
                    state.guestInterventions = value;
                },
                GET_GUEST_INTERVENTIONS_COUNT(state, value) {
                    state.guestInterventionsCount = value;
                },
                GET_CURRENT_PAGE(state, value) {
                    state.currentPage = value;
                },
                GET_TOTAL_PAGES(state, value) {
                    state.totalPages = value;
                },
                GET_SEARCH_QUERY(state, value) {
                    state.searchQuery = value;
                },
            },
            actions: {
                getGuestInterventions({commit, state}) {
                    const requestUrl = !state.searchQuery
                        ? `${baseUrl}/guest/interventions?page=${state.currentPage}`
                        : `${baseUrl}/guest/interventions?page=${state.currentPage}&filter[search]=${
                            encodeURIComponent(state.searchQuery)
                        }`;

                    axios
                        .get(requestUrl, {
                            headers: {
                                Authorization: `Bearer ${window.localStorage.getItem("token")}`
                            }
                        })
                        .then(function (response) {
                            commit("GET_GUEST_INTERVENTIONS", response.data.data);
                            commit("GET_PER_PAGE_TOTAL", response.data.meta.per_page);
                            commit("GET_GUEST_INTERVENTIONS_COUNT", response.data.meta.total);
                            commit("GET_TOTAL_PAGES", Math.ceil(state.guestInterventionsCount / state.perPageTotal));
                            console.log(state.totalPages)
                        })
                        .catch(function (error) {
                            commit("GET_ERRORS", error);
                        });
                },
                getCurrentPage({commit, dispatch}, value) {
                    commit("GET_CURRENT_PAGE", value);
                    dispatch("getGuestInterventions");
                },
                getSearchQuery({commit}, value) {
                    commit("GET_SEARCH_QUERY", value);
                },
                requestSearch({commit, dispatch}) {
                    commit("GET_CURRENT_PAGE", 1);
                    dispatch("getGuestInterventions");
                },
            },
            getters: {
                perPageTotal: state => state.perPageTotal,
                errors: state => state.errors,
                guestInterventions: state => state.guestInterventions,
                guestInterventionsCount: state => state.guestInterventionsCount,
                currentPage: state => state.currentPage,
                totalPages: state => state.totalPages,
                searchQuery: state => state.searchQuery,
            }
        }},

});
